export default __webpack_public_path__ + "static/media/027-sea level.3bbed855.svg";